const registry = require('../registry');

/**
 * @type {import('../registry').ExtractAccessFunction}
 */
function extractAccess(hNode, options) {
    // saved filters and shared filters are special. they get a weird popup to get more information.
    // But there are already action buttons that would configure the access.
    // Also, shared filters re-use the same savedFilters popup.
    // so, just stop processing the tree when we hit a dialog for saved filters.
    if (hNode.relation === 'savedFilter') {
        let spec = [];
        let access = {};

        return { spec, access };
    }
    return registry.hNode.extractAccess(hNode, options);
}
const dialogs = {
    SimpleDialog: { extractAccess }
};
registry.register('dialogs', dialogs);
module.exports = dialogs;
